/**
 * This is used for the introduction wizard
 */

import { Decision } from "./decision";

export class Summary {
   enable: Boolean;
   decisions: Decision[] = [];
   traversed: any[];
   date: Date;
   level: string;

   constructor(enable: boolean, decisions: Decision[], traversed: any[], level?: string) {
    this.enable = enable;
    this.decisions = decisions;
    this.traversed = traversed;
    this.date = new Date();
    this.level = level || '';
   }
}